import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-background-style-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-background-style-form.component.html',
    styleUrls: ['./free-form-background-style-form.component.scss'],
    standalone: false
})
export class FreeFormBackgroundStyleFormComponent {
  #isSubmitted = signal(false);
  #freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle;
  freeFormStyleForm = new FormGroup(
    {
      background: new FormControl(false),
      color: new FormControl(''),
      backgroundInBorderColor: new FormControl(false),
      opacity: new FormControl(40),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.pick({
          background: true,
          color: true,
          backgroundInBorderColor: true,
          opacity: true,
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form Style
    this.slideAuthorFacade.currentSelectedSlideFreeFormStyle$.pipe(takeUntilDestroyed()).subscribe((freeFormStyle) => {
      this.#freeFormStyle = structuredClone(freeFormStyle);
      if (freeFormStyle) {
        this.freeFormStyleForm.reset({
          background: this.#freeFormStyle.background,
          color: this.#freeFormStyle.color,
          backgroundInBorderColor: this.#freeFormStyle.backgroundInBorderColor,
          opacity: (this.#freeFormStyle.opacity || 0) * 100,
        });
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.freeFormStyleForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeFormStyle = assign(
      this.#freeFormStyle,
      {
        background: this.freeFormStyleForm.value.background,
        color: this.freeFormStyleForm.value.color,
        backgroundInBorderColor: this.freeFormStyleForm.value.backgroundInBorderColor,
        opacity: (Number.isInteger(this.freeFormStyleForm.value.opacity) && this.freeFormStyleForm.value.opacity !== 0) ? ((this.freeFormStyleForm.value.opacity || 0) / 100) : null,
      }
    );
    this.slideAuthorFacade.requestUpdateFreeFormStyle(freeFormStyle, 'history.free_form_update_style').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.freeFormStyleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
  
  onShowBackground() {
    if (this.freeFormStyleForm.value.background && (!this.freeFormStyleForm.value.opacity || this.freeFormStyleForm.value.opacity === 0)) {
      this.freeFormStyleForm.patchValue({opacity: 40 });
    }
    this.onSubmit();
  }
}
